import { Deserializable } from '../protocols/deserializable';
import { MonthlyPensionAnnuityType } from '../shared/monthly-pension-annuity-type';
import { MonthlyPensionAnnuityTypeIdEnum } from '../enum/shared/monthly-pension-annuity-type-id.enum';
import { AnnuityGuaranteePeriodType } from '../shared/annuity-guarantee-period-type';
import { AnnuityGuaranteeTypeIdEnum } from '../enum/shared/annuity-guarantee-type-id.enum';
import { MonthlyPensionAccountStateTypeEnum } from './enum/monthly-pension-account-state-type.enum';
import { MonthlyPensionAccountPaymentInstructionDesignationEnum } from './enum/monthly-pension-account-payment-instruction-designation.enum';
import { MonthlyPensionAccountPaymentInstructionStatusEnum } from './enum/monthly-pension-account-payment-instruction-status.enum';
import { MonthlyPensionAccountPaymentInstructionDispositionEnum } from './enum/monthly-pension-account-payment-instruction-disposition.enum';
import { MonthlyPensionBenefitPhase } from './monthly-pension-benefit-phase';
import { PaymentMethodTypeIdEnum } from '../enum/shared/payment-method-type-id.enum';
import { PaymentMethodType } from '../shared/payment-method-type';
import { BankAccount } from '../../views/banking/models/bank-account';
import { PaylineAccount } from '../../views/banking/models/payline-account';

export class MonthlyPensionEntitlement implements Deserializable {
  public paymentInstructionId!: string;
  public accountId!: number;
  public accountOwnerMemberId!: number | null;
  public continuationFromName!: string;
  public continuationFromMemberId!: number | null;
  public annuityTypeId!: MonthlyPensionAnnuityTypeIdEnum;
  public annuityType!: MonthlyPensionAnnuityType;
  public annuityGuaranteePeriodId!: AnnuityGuaranteeTypeIdEnum;
  public annuityGuaranteePeriod!: AnnuityGuaranteePeriodType;
  public guaranteeEndDate!: string | null;
  public stateId!: MonthlyPensionAccountStateTypeEnum;
  public payeeDesignationId!: MonthlyPensionAccountPaymentInstructionDesignationEnum;
  public allocationPercentage!: number;
  public paymentAmount!: number;
  public monthlyAmount!: number | null;
  public benefitSchedule!: MonthlyPensionBenefitPhase[];
  public statusId!: MonthlyPensionAccountPaymentInstructionStatusEnum;
  public dispositionId!: MonthlyPensionAccountPaymentInstructionDispositionEnum | null;
  public commutedValue!: number | null;
  public startDate!: string;
  public endDate!: string | null;
  public splitEffectiveDate!: string | null;
  public paymentMethodId!: PaymentMethodTypeIdEnum | null;
  public paymentMethod!: PaymentMethodType | null;
  public bankAccountId!: number | null;
  public bankAccount!: BankAccount | null;
  public paylineAccountId!: number | null;
  public paylineAccount!: PaylineAccount | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.annuityType) {
      this.annuityType = Deserialize.instanceOf(MonthlyPensionAnnuityType, this.annuityType);
    }

    if (this.annuityGuaranteePeriod) {
      this.annuityGuaranteePeriod = Deserialize.instanceOf(AnnuityGuaranteePeriodType, this.annuityGuaranteePeriod);
    }

    this.benefitSchedule = Deserialize.arrayOf(MonthlyPensionBenefitPhase, this.benefitSchedule ?? []);

    if (this.paymentMethod) {
      this.paymentMethod = Deserialize.instanceOf(PaymentMethodType, this.paymentMethod);
    }

    if (this.bankAccount) {
      this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
    }

    if (this.paylineAccount) {
      this.paylineAccount = Deserialize.instanceOf(PaylineAccount, this.paylineAccount);
    }
  }
}
